<form-section [subtitle]="'Controller software'"
              data-testid="controller-software">
    <div class="p16">
        <form-item-text [subtitle]="'NOTE: Software update shall be\n'+
            'conducted only by a qualified fitter.\n'+
            'Do not switch the controller off while updating the software.\n'+
            'After the software has been updated, it is not possible to\n'+
            'restore previous settings.'">
        </form-item-text>
    </div>
    <form-link [subtitle]="'UTFH8ZMP'"
               [value]="'v2.2.10'"
               [href]="'/public/download/software/UFH8ZMP/2.2.10/st2640u.bin'"
               [download]="'st2640u.bin'">
    </form-link>
    <div class="px-16">
        <form-item-text [subtitle]="'In order to install new software, the controller must be\n'+
            'unplugged from the power supply. Next, insert the memory stick \n'+
            'with the new software into the USB port. Connect the controller \n'+
            'to the power supply at the same time holding EXIT button.\n'+
            'It is necessary to hold down the EXIT button until a single beep\n'+
            'is heard, this indicates that the software update process has \n'+
            'been initiated. After it has been completed, the controller \n'+
            'restarts automatically.'">
        </form-item-text>
    </div>
    <form-link [subtitle]="'UFHINTWIFIP'"
               [value]="'v2.1.3'"
               [href]="'/public/download/software/UFHINTWIFIP/2.1.3/ST-5060.bin'"
               [download]="'ST-5060.bin'">
    </form-link>
    <div class="px-16">
        <form-item-text [subtitle]="'In order to install new software, the controller must be\n'+
            'unplugged from the power supply. Next, insert the memory stick \n'+
            'with the new software into the USB port. Connect the controller\n'+
            'to the power supply. A single sound signal signalises\n'+
            'that the software update process has been initiated.'">
        </form-item-text>
    </div>
    <form-link [subtitle]="'UFHTFT'"
               [value]="'v2.0.17'"
               [href]="'/public/download/software/UFHTFT/2.0.17/st286R8u.bin'"
               [download]="'st286R8u.bin'">
    </form-link>
    <div class="px-16">
        <form-item-text [subtitle]="'In order to install new software, the controller must be\n'+
            'unplugged from the power supply. Next, insert the memory stick \n'+
            'with the new software into the USB port. Connect the\n'+
            'controller to the power supply. A single sound signal signalises\n'+
            'that the software update process has been initiated.'">
        </form-item-text>
    </div>
    <form-link [subtitle]="'UFHTFT'"
               [value]="'v2.2.2'"
               [href]="'/public/download/software/UFHTFTM/2.2.2/st285M8u.bin'"
               [download]="'st285M8u.bin'">
    </form-link>
    <div class="px-16">
        <form-item-text [subtitle]="'In order to install new software, the controller must be\n'+
            'unplugged from the power supply. Next, insert the memory stick \n'+
            'with the new software into the USB port. Connect the\n'+
            'controller to the power supply. A single sound signal signalises\n'+
            'that the software update process has been initiated.'">
        </form-item-text>
    </div>
</form-section>
